import { render } from "./FormulaireModal.vue?vue&type=template&id=1c8130ca"
import script from "./FormulaireModal.vue?vue&type=script&lang=js"
export * from "./FormulaireModal.vue?vue&type=script&lang=js"

import "./FormulaireModal.vue?vue&type=style&index=0&id=1c8130ca&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__